'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _odataFilterBuilder = require('odata-filter-builder');

var _odataFilterBuilder2 = _interopRequireDefault(_odataFilterBuilder);

var _messages = require('common/messages');

var _query = require('utilities/query');

var _systemIngredients = require('./system-ingredients.html');

var _systemIngredients2 = _interopRequireDefault(_systemIngredients);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _systemIngredients2.default,
  bindings: {
    flex: '@',
    layout: '@',
    ingredients: '<',
    query: '<'
  },
  controller: function () {
    function SystemIngredientsComponent($mdDialog, $scope, ToastService, SystemIngredientsService) {
      'ngInject';

      _classCallCheck(this, SystemIngredientsComponent);

      Object.assign(this, {
        $mdDialog: $mdDialog,
        $scope: $scope,
        ToastService: ToastService,
        SystemIngredientsService: SystemIngredientsService
      });
    }

    _createClass(SystemIngredientsComponent, [{
      key: '$onInit',
      value: function $onInit() {
        this.columns = [{
          FieldName: 'SystemIngredientName',
          DisplayName: 'Ingredient Name'
        }, {
          FieldName: 'IUtoMgConversiontRate',
          DisplayName: '1 IU to MG Conversion Rate'
        }];

        this.selectedIngredients = [];
      }
    }, {
      key: 'onQueryChanged',
      value: function onQueryChanged(_ref) {
        var query = _ref.query;

        this.selectedIngredients = [];
        this.query = query;
        this.refreshResults();
      }
    }, {
      key: 'onSearchTextChanged',
      value: function onSearchTextChanged(_ref2) {
        var searchText = _ref2.searchText;

        this.selectedIngredients = [];
        this.query = _extends({}, this.query, {
          filter: (0, _odataFilterBuilder2.default)().contains('SystemIngredientName', searchText)
        });

        this.refreshResults();
      }
    }, {
      key: 'refreshResults',
      value: function refreshResults() {
        var _this = this;

        this.promise = this.SystemIngredientsService.search(this.query);
        this.promise.then(function (r) {
          _this.ingredients = (0, _query.transformODataResponse)(r);
        }).catch(function (error) {
          return _this.ToastService.showError(error);
        });
      }
    }, {
      key: 'ingredientAdd',
      value: function ingredientAdd() {
        var _this2 = this;

        var scope = _angular2.default.extend(this.$scope.$new(true), {
          ingredientChanged: function ingredientChanged($event) {
            return _this2.onIngredientAdded($event);
          }
        });

        this.$mdDialog.show({
          clickOutsideToClose: true,
          fullscreen: true,
          scope: scope,
          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <system-ingredient-form\n                dialog-title="Add New System Ingredient"\n                submit-title="Add System Ingredient"\n                ingredient-changed="ingredientChanged($event)">\n              </system-ingredient-form>\n            </md-dialog-content>\n          </md-dialog>\n          '
        });
      }
    }, {
      key: 'onIngredientAdded',
      value: function onIngredientAdded(_ref3) {
        var _this3 = this;

        var ingredient = _ref3.ingredient;

        this.SystemIngredientsService.add(ingredient).then(function () {
          _this3.$mdDialog.hide();
          _this3.refreshResults();
          _this3.ToastService.showSuccess(_messages.SYSTEM_INGREDIENT_ADDED);
        }).catch(function (error) {
          return _this3.ToastService.showError(error);
        });
      }
    }, {
      key: 'ingredientEdit',
      value: function ingredientEdit(ingredient) {
        var _this4 = this;

        var scope = _angular2.default.extend(this.$scope.$new(true), {
          ingredient: _angular2.default.copy(ingredient),
          ingredientChanged: function ingredientChanged($event) {
            return _this4.onIngredientEdited($event);
          }
        });

        this.$mdDialog.show({
          clickOutsideToClose: true,
          fullscreen: true,
          scope: scope,
          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <system-ingredient-form\n                ingredient="ingredient"\n                dialog-title="Edit System Ingredient"\n                submit-title="Save Changes"\n                ingredient-changed="ingredientChanged($event)">\n              </system-ingredient-form>\n            </md-dialog-content>\n          </md-dialog>\n          '
        });
      }
    }, {
      key: 'ingredientDelete',
      value: function ingredientDelete(ingredients) {
        var _this5 = this;

        var confirm = this.$mdDialog.confirm().title('Are you sure?').textContent('Once deleted, the selected ingredient(s) cannot be recovered!').ok('Delete').cancel('Cancel');

        this.$mdDialog.show(confirm).then(function () {
          var promises = [];
          for (var i = ingredients.length - 1; i >= 0; i -= 1) {
            promises.push(_this5.SystemIngredientsService.delete(ingredients[i].SystemIngredientId));
          }

          Promise.all(promises).then(function () {
            _this5.ToastService.showSuccess(_messages.SYSTEM_INGREDIENT_DELETED);
            _this5.refreshResults();
            _this5.selectedIngredients = [];
          }).catch(function (error) {
            return _this5.ToastService.showError(error);
          });
        });
      }
    }, {
      key: 'onIngredientEdited',
      value: function onIngredientEdited(_ref4) {
        var _this6 = this;

        var ingredient = _ref4.ingredient;

        this.SystemIngredientsService.update(ingredient).then(function () {
          _this6.$mdDialog.hide();
          _this6.selectedIngredients = [];
          _this6.refreshResults();
          _this6.ToastService.showSuccess(_messages.SYSTEM_INGREDIENT_EDITED);
        }).catch(function (error) {
          return _this6.ToastService.showError(error);
        });
      }
    }]);

    return SystemIngredientsComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/admin/system-ingredients/system-ingredients.component.js